import { $translate } from '@/utils/i18n';
export const tableConfig = {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: true,
        leftOperation: false,
        height: 400,
        columns: [
            // 序号，文件名，上传人，上传时间，批次号
            {
                label: $translate('lang.E3202207280001', { defaultText: '文件名' }),
                align: 'center',
                prop: 'fileName',
                value: '',
                filter: true,
                require: true,
                sort: false,
                width: 130
            },
            {
                label: $translate('lang.E3202207280002', { defaultText: '上传人' }),
                align: 'center',
                prop: 'uploadBy',
                value: '',
                filter: true,
                require: true,
                sort: false,
                width: 130
            },
            {
                label: $translate('lang.E3202207280003', { defaultText: '上传时间' }),
                align: 'center',
                prop: 'uploadTime',
                value: '',
                filter: true,
                require: true,
                sort: false,
                width: 130
            },
            {
                label: $translate('lang.E3202207280004', { defaultText: '批次号' }),
                align: 'center',
                prop: 'batchId',
                value: '',
                filter: true,
                require: true,
                // fixed: 'left',
                sort: false,
                width: 160
            }

        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
